import React from 'react';

import FeedbackCriteriaSection from './FeedbackCriteriaSection';

const QuestionFooter = ({ hint, feedbackCriteria, updateFeedbackCriteria }) => (
  <footer className="EditorElement-footer">
    <div className="EditorElement-hint">{hint}</div>
    <FeedbackCriteriaSection
      feedbackCriteria={feedbackCriteria}
      updateFeedbackCriteria={updateFeedbackCriteria}
    />
  </footer>
);

export default QuestionFooter;
